import React from 'react';
import { Marker, Popup, LayerGroup, withLeaflet } from 'react-leaflet';
import { Icon } from 'leaflet';

// TODO(@nampnq): Add support for MapBox (not important, because almost no longer used)

//
// I get list pharmacies from our map
// https://www.google.com/maps/d/embed?mid=1POVJkLfIGnNqGEMUKhO2Ru5Im_Z-UC9m&ll=48.23621940488409%2C2.2494569506205675&z=6
// data[1][6][0][12][0][13][0].map(x=>({name: x[5][0][1][0], location: x[1][0][0], address: `${x[5][3][0][1]}, ${x[5][3][1][1][0]} ${x[5][3][2][1][0]}`}))
//

type Pharmacie$Type = {
  name: string;
  address: string;
  location: [number, number];
};

type Props = {
  leaflet: {
    map: {
      on: (event: string, handler: Function) => void;
      off: (event: string, handler: Function) => void;
      getZoom: () => number;
    };
  };
};

const pharmacieIcon = new Icon({
  iconUrl: '/static/icons/marker-pharmacies.svg',
  iconSize: [18, 24],
  className: 'marker-pharmacies',
});

const Pharmacies = ({ leaflet }: Props) => {
  const [items, setItems] = React.useState<Pharmacie$Type[]>([]);

  React.useEffect(() => {
    fetch('/data/pharmacies.json')
      .then(r => r.json())
      .then(r => setItems(r));
  }, []);

  React.useEffect(() => {
    const styleSheet = document.createElement('style');
    const handler = () => {
      // @ts-ignore
      const currentDisplay = styleSheet.sheet.cssRules.item(0).style.display;
      const newDisplay = leaflet.map.getZoom() >= 12 ? 'block' : 'none';
      if (currentDisplay !== newDisplay)
        // @ts-ignore
        styleSheet.sheet.cssRules.item(0).style.display = newDisplay;
    };
    styleSheet.innerHTML = '.marker-pharmacies {display: block}';
    document.body.appendChild(styleSheet);
    leaflet.map.on('zoomend', handler);
    return () => {
      leaflet.map.off('zoomend', handler);
      document.body.removeChild(styleSheet);
    };
  }, []);

  return (
    <LayerGroup>
      {items.map(item => (
        <Marker
          key={item.address}
          position={item.location}
          icon={pharmacieIcon}
        >
          <Popup>
            <strong>Nom :</strong> {item.name} <br />
            <strong>Adresse :</strong> {item.address}
          </Popup>
        </Marker>
      ))}
    </LayerGroup>
  );
};

const PharmaciesMemo = withLeaflet(React.memo(Pharmacies));

export default PharmaciesMemo;
